export class InformacionLaboral {
  tipo?: string;
  tipoActividad?: string;
  ingresos: {
    salario: {
      tipo: string,
      basico: string
    }
  };
  contrato: {
    tipo: string,
    horasDiaria: string,
    horasMes?: string,
    fechaIngreso?: string
  };

  static instance(esTiTular = false) {
    const infoLaboralDto = new this();

    if (!esTiTular)
      delete infoLaboralDto.tipo;
    else
      delete infoLaboralDto.tipoActividad;

    return infoLaboralDto;
  }
}
